import {
  MedicationRouteCode,
  MedicationRouteCodeDescription,
  type MedicationSchedule,
} from '@quromedical/models';
import { difference } from '@quromedical/utils';

/**
 * Route codes as determined from the list of supported codes with their descriptions
 */
export const allRouteCodes = Object.keys(
  MedicationRouteCodeDescription,
) as MedicationRouteCode[];

/**
 * Non-medication route codes
 *
 * @example BAN - Bandage
 * @example CSM - Consumable
 */
export const nonMedicationRouteCodes: MedicationRouteCode[] = [
  MedicationRouteCode.UNI,
  MedicationRouteCode.CPS,
  MedicationRouteCode.VAG,
  MedicationRouteCode.PAI,
  MedicationRouteCode.SCR,
  MedicationRouteCode.WAF,
  MedicationRouteCode.SWB,
  MedicationRouteCode.IMP,
  MedicationRouteCode.KIT,
  MedicationRouteCode.AMP,
  MedicationRouteCode.PAT,
  MedicationRouteCode.BDL,
  MedicationRouteCode.TUL,
  MedicationRouteCode.PLA,
  MedicationRouteCode.BAN,
  MedicationRouteCode.GAU,
  MedicationRouteCode.VRI,
  MedicationRouteCode.VIA,
  MedicationRouteCode.MET,
  MedicationRouteCode.TES,
  MedicationRouteCode.CLS,
  MedicationRouteCode.SNG,
  MedicationRouteCode.COT,
  MedicationRouteCode.BRA,
  MedicationRouteCode.AQS,
  MedicationRouteCode.DEV,
  MedicationRouteCode.NDL,
  MedicationRouteCode.SUT,
  MedicationRouteCode.SWS,
  MedicationRouteCode.PVC,
  MedicationRouteCode.NSS,
  MedicationRouteCode.BAS,
  MedicationRouteCode.PAP,
  MedicationRouteCode.SLW,
  MedicationRouteCode.SPC,
  MedicationRouteCode.SCT,
  MedicationRouteCode.NIC,
  MedicationRouteCode.PSD,
  MedicationRouteCode.SCL,
  MedicationRouteCode.TPN,
  MedicationRouteCode.MC2,
  MedicationRouteCode.DRE,
  MedicationRouteCode.MC3,
  MedicationRouteCode.GAS,
  MedicationRouteCode.MC1,
  MedicationRouteCode.PTD,
  MedicationRouteCode.CAT,
  MedicationRouteCode.CES,
  MedicationRouteCode.DES,
  MedicationRouteCode.DEB,
  MedicationRouteCode.BIS,
  MedicationRouteCode.CPC,
  MedicationRouteCode.GRE,
  MedicationRouteCode.GUS,
  MedicationRouteCode.JES,
  MedicationRouteCode.OIR,
  MedicationRouteCode.SLL,
  MedicationRouteCode.STI,
  MedicationRouteCode.OGS,
  MedicationRouteCode.JUT,
  MedicationRouteCode.REN,
  MedicationRouteCode.HEA,
  MedicationRouteCode.ODF,
  MedicationRouteCode.ZZZ,
  MedicationRouteCode.PLS,
  MedicationRouteCode.CSM,
  MedicationRouteCode.FLS,
];

/**
 * Route codes that represent medications
 *
 * @example INJ - Injection
 * @example TAB - Tablet
 */
export const medicationRouteCodes = difference(
  allRouteCodes,
  nonMedicationRouteCodes,
);

/**
 * These are the schedule codes we use to filter medication we get from medprax and can order from
 * pharmacies without any special validation needed.
 * Schedule 5 and 6 medication require extra validation, and hence have a special way to order.
 */
export const normalSchedules: MedicationSchedule[] = ['1', '2', '3', '4'];

export const allSchedules: MedicationSchedule[] = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
];
